
import { Cliente, Gerador } from "@/types";

export interface EnergiaResumo {
  totalClientes: number;
  totalConsumo: number;
  percentualUsoGerador: number;
  totalEconomia: number;
  receitaTotal: number;
  ultimaAtualizacao: Date;
}

export const calculateEnergiaResumo = (
  clientes: Cliente[], 
  geradores: Gerador[],
  ultimaAtualizacao: Date = new Date()
): EnergiaResumo => {
  // Cálculos simplificados para dashboard
  const totalClientes = clientes.length;
  const totalConsumo = clientes.reduce((acc, cliente) => {
    const consumo = cliente.gastoEnergia / cliente.tarifaEnergia || 0;
    return acc + consumo;
  }, 0);
  
  const totalGeracaoDisponivel = geradores.reduce((acc, gerador) => {
    return acc + gerador.geracaoEstimada;
  }, 0);
  
  const percentualUsoGerador = totalGeracaoDisponivel > 0 
    ? (totalConsumo / totalGeracaoDisponivel) * 100 
    : 0;
  
  const totalEconomia = clientes.reduce((acc, cliente) => {
    const consumo = cliente.gastoEnergia / cliente.tarifaEnergia || 0;
    const gerador = geradores.find(g => g.id === cliente.geradorId);
    
    if (gerador) {
      const economia = consumo * (cliente.tarifaEnergia - gerador.tarifaVenda);
      return acc + economia;
    }
    return acc;
  }, 0);
  
  const receitaTotal = clientes.reduce((acc, cliente) => {
    const consumo = cliente.gastoEnergia / cliente.tarifaEnergia || 0;
    const gerador = geradores.find(g => g.id === cliente.geradorId);
    
    if (gerador) {
      const receita = consumo * gerador.tarifaVenda;
      return acc + receita;
    }
    return acc;
  }, 0);
  
  return {
    totalClientes,
    totalConsumo,
    percentualUsoGerador,
    totalEconomia,
    receitaTotal,
    ultimaAtualizacao
  };
};

export const getTopGeradores = (geradores: Gerador[], limit: number = 3) => {
  return [...geradores]
    .sort((a, b) => b.creditosDisponiveis - a.creditosDisponiveis)
    .slice(0, limit);
};

export const getTopClientes = (clientes: Cliente[], limit: number = 3) => {
  return [...clientes]
    .sort((a, b) => {
      const consumoA = a.gastoEnergia / a.tarifaEnergia || 0;
      const consumoB = b.gastoEnergia / b.tarifaEnergia || 0;
      return consumoB - consumoA;
    })
    .slice(0, limit);
};
